import React from 'react';

interface ArrowButtonProps {
  backgroundColor?: string;
  direction?: 'left' | 'right';
  className?: string;
  disabled?: boolean;
}

export const ArrowButton: React.FC<ArrowButtonProps> = ({
  backgroundColor = '#FFFFFF',
  direction = 'left',
  className = '',
  disabled = false,
}) => {
  const arrowFill = disabled ? 'rgb(var(--color-arrow-disabled))' : 'rgb(var(--color-primary))';
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <circle cx="12" cy="12" r="12" fill={backgroundColor} />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d={
          direction === 'left'
            ? 'M13.7071 16.7071C14.0976 16.3166 14.0976 15.6834 13.7071 15.2929L10.4142 12L13.7071 8.70711C14.0976 8.31658 14.0976 7.68342 13.7071 7.29289C13.3166 6.90237 12.6834 6.90237 12.2929 7.29289L8.29289 11.2929C7.90237 11.6834 7.90237 12.3166 8.29289 12.7071L12.2929 16.7071C12.6834 17.0976 13.3166 17.0976 13.7071 16.7071Z'
            : 'M10.2929 7.29289C9.90237 7.68342 9.90237 8.31658 10.2929 8.70711L13.5858 12L10.2929 15.2929C9.90237 15.6834 9.90237 16.3166 10.2929 16.7071C10.6834 17.0976 11.3166 17.0976 11.7071 16.7071L15.7071 12.7071C16.0976 12.3166 16.0976 11.6834 15.7071 11.2929L11.7071 7.29289C11.3166 6.90237 10.6834 6.90237 10.2929 7.29289Z'
        }
        fill={arrowFill}
      />
    </svg>
  );
};
